const { VERSION } = require("~/configs/version");
const { persistor } = require(".");

const localVersion = localStorage.getItem("version");
if (localVersion) {
  if (Number(localVersion) !== VERSION) {
    window.localStorage.removeItem("jwt");
    persistor.purge();
  }
} else {
  persistor.purge();
}

localStorage.setItem("version", VERSION);
